__turbopack_context__.v({
  "fade": "RevealOnScroll-module__VmJH4W__fade",
  "fade-down": "RevealOnScroll-module__VmJH4W__fade-down",
  "fade-left": "RevealOnScroll-module__VmJH4W__fade-left",
  "fade-right": "RevealOnScroll-module__VmJH4W__fade-right",
  "fade-up": "RevealOnScroll-module__VmJH4W__fade-up",
  "reveal": "RevealOnScroll-module__VmJH4W__reveal",
  "scale": "RevealOnScroll-module__VmJH4W__scale",
  "visible": "RevealOnScroll-module__VmJH4W__visible",
});
